// Registro globale "modifiche non salvate" per i pannelli admin.
// Il pannello attivo registra { dirty(), save(), discard() }; la pagina Admin
// intercetta cambi di tab / navigazione / chiusura e chiede conferma con un dialogo.
let handler = null;

export function registerUnsaved(h) {
  handler = h;
}

export function unregisterUnsaved(h) {
  if (handler === h) handler = null;
}

export function hasUnsaved() {
  try {
    return !!(handler && handler.dirty());
  } catch {
    return false;
  }
}

export async function saveUnsaved() {
  if (handler) await handler.save();
}

export function discardUnsaved() {
  if (handler) handler.discard();
}
